import { Theme } from "@mui/material";

import { encampBrandColors } from "../../colors";

/** driver.js hard-codes the overlay at z-index 10000; temporary MUI Drawer is ~1300. */
const DRIVER_OVERLAY_Z_INDEX = 10_000;
const MOBILE_NAV_ABOVE_OVERLAY_Z_INDEX = DRIVER_OVERLAY_Z_INDEX + 1;

export const MOBILE_NAV_TOUR_CLASS = "spotlight-tour--mobile-nav";
export const SPOTLIGHT_POPOVER_CLASS = "spotlight-tour-popover";

/** driver.js ships its own CSS, so the theming is all overrides of its classes. */
export function spotlightTourStyles(theme: Theme) {
  return {
    // Temporary Drawer mounts in a Modal (~z-index 1300) under driver.js's overlay
    // (10000). Raise the drawer so a nav anchor is visible through the stage.
    [`html.${MOBILE_NAV_TOUR_CLASS} .MuiDrawer-root`]: {
      zIndex: MOBILE_NAV_ABOVE_OVERLAY_Z_INDEX,
    },
    // Driver overlay already dims the page; hide the Drawer backdrop to avoid double dim.
    [`html.${MOBILE_NAV_TOUR_CLASS} .MuiDrawer-root > .MuiBackdrop-root`]: {
      opacity: 0,
      pointerEvents: "none",
    },
    [`.${SPOTLIGHT_POPOVER_CLASS}`]: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      borderRadius: 8,
      maxWidth: 320,
      boxShadow: theme.shadows[8],
    },
    [`.${SPOTLIGHT_POPOVER_CLASS} .driver-popover-title`]: {
      fontSize: 16,
      fontWeight: 700,
      color: theme.palette.text.primary,
    },
    [`.${SPOTLIGHT_POPOVER_CLASS} .driver-popover-description`]: {
      fontSize: 14,
      color: theme.palette.text.secondary,
    },
    [`.${SPOTLIGHT_POPOVER_CLASS} .driver-popover-progress-text`]: {
      fontSize: 12,
      color: theme.palette.text.secondary,
    },
    [`.${SPOTLIGHT_POPOVER_CLASS} .driver-popover-next-btn`]: {
      backgroundColor: "transparent",
      color: encampBrandColors.sapphire,
      border: `1px solid ${encampBrandColors.sapphire}`,
      borderRadius: 4,
      textShadow: "none",
      fontSize: 13,
      fontWeight: 500,
      padding: "4px 12px",
    },
    [`.${SPOTLIGHT_POPOVER_CLASS} .driver-popover-next-btn:hover`]: {
      backgroundColor: "rgba(15, 95, 107, 0.08)",
    },
    [`.${SPOTLIGHT_POPOVER_CLASS} .driver-popover-close-btn`]: {
      color: theme.palette.text.secondary,
    },
    ".driver-active-element": {
      outline: `2px solid ${encampBrandColors.pumpkin} !important`,
      borderRadius: "8px",
    },
  };
}
